import React from "react";
import styles from "../utils/gridStyles.js";
import setHeaderRender from "../../components/app/setHeaderRender";
import dateFormat from 'dateformat';

const setColumns = ({ modalDetail, allowWrite, changeDelay}) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'code', changeDelay, tableManager, column}) )
        },
        {
            id: "2",
            field: "name",
            label: "Name",
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Name', changeDelay, tableManager, column}) )
        },
        {
            id: "3",
            field: "price",
            label: "Price",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Price', changeDelay, tableManager, column}) )
        },
        {
            id: "4",
            label: 'Category',
            field: "category",
            width: "200px",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Category', changeDelay, tableManager, column}) )
        },
        {
            id: "5",
            field: "comission",
            label: "Comission",
            sortable: false
        },
        {
            id: "6",
            field: "hasFreeTrial",
            label: "FreeTrial",
            sortable: false
        },
        {
            id: "7",
            field: "description",
            label: "Description",
            sortable: false,
            width: "500px",
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Description', changeDelay, tableManager, column}) )
        },
        {
            id: "8",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy", true)),
        },
        {
            id: "buttons",
            label: "Action",
            width: '110px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                    {allowWrite
                        ? (<> <button
                            title="Edit"
                            style={styles.styleButton.editButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                modalDetail(data.code, "Edit");
                            }}
                        >
                            {styles.EDIT_SVG}
                        </button> {" - "}
                        </>)
                        : ''
                    }
                </div>
            )
        }
    ];
};

export default setColumns;
